<template>
  <div>
    <Topo class="naoImprimir" v-if="!$verificaPerfilHabilitador() && !$verificaPerfilCadastrador()" :btnLogout="true" :acessoRestritoMenu="false"></Topo>
    <CabecalhoImpressao class="imprimir" hidden></CabecalhoImpressao>
    <Migalha label="Histórico de Solicitações" v-if="!$verificaPerfilHabilitador() && !$verificaPerfilCadastrador()"></Migalha>
    <br>
    <v-layout row d-inline class="p-t-30">
      <v-flex xs12 v-if="!$verificaPerfilHabilitador() && !$verificaPerfilCadastrador()">
        <div class="right p-l-10">
          <v-btn
          slot="activator"
          color="primary"
          class="mb-2"
          v-print>Imprimir
            <v-icon dark right>print</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12  v-if="podeSolicitarAlteracao()">
        <div class="right p-l-10">
          <v-btn slot="activator" color="primary" class="mb-2" @click="solicitarAlteracao()">
            Solicitar Alteração
            <v-icon dark right>edit</v-icon>
          </v-btn>
        </div>
      </v-flex>
       <v-flex xs12  v-if="podeSolicitarCadastro()">
        <div class="right p-l-10">
          <v-btn slot="activator" color="primary" class="mb-2" @click="solicitarCadastro()">
            Solicitar Cadastro
            <v-icon dark right>person</v-icon>
          </v-btn>
         </div>
      </v-flex>
    <!-- <v-layout column>
    <v-layout row>
       <v-flex xs12 v-if="flMostrarBotaoTermoVeracidade()">
        <div class="right p-l-10">
          <v-btn slot="activator" color="primary" class="mb-2" @click="termoConcordancia()">
            Termo de Concordância e Veracidade
            <v-icon dark right>check</v-icon>
          </v-btn>
         </div>
      </v-flex>
      <v-flex xs12 v-if="!$verificaPerfilCadastrador() && !$verificaPerfilHabilitadorMaster() && veracidadecarregado && uploadDeclaracao.termoConcordanciaVeracidadeSaeb && uploadDeclaracao.termoConcordanciaVeracidadeSaeb != 'Não Encontrado' && !solicitacaoComTermoRejeitado">
        <div class="right p-l-10">
          <v-btn slot="activator" color="primary" class="mb-2" @click="baixarArquivo(uploadDeclaracao.termoConcordanciaVeracidadeSaeb)">
            Termo de Concordância e Veracidade
            <v-icon dark right>check</v-icon>
          </v-btn>
         </div>
      </v-flex>
      </v-layout>
      <v-layout row justify-end v-if="!$verificaPerfilCadastrador() && !$verificaPerfilHabilitadorMaster() && !possuiTermoAceito">
        <v-flex xs7>
          <p class="text_color">Possui Certificado Digital? <a class="link_color" v-on:click="openModalUploadTermo()">Clique aqui </a>para envio do <b class="text_bold_color">Termo de Concordância e Veracidade</b> assinado digitalmente. Sua solicitação somente será analisada após o envio do referido documento.</p>
        </v-flex>
      </v-layout>
    </v-layout> -->
    <v-layout row justify-end v-if="exibeCardFornecedor">
      <v-flex xs8 md6>
        <div class="boxConteudoNomeFornecedor">
          <h3 class="display-1 text-primary">{{model.nomFornecedor }}</h3>
          <div class>
            <strong>{{(model.tipFornecedor =='J') ? $t('label.pessoaJurica') : $t('label.pessoaFisica')}}</strong>
          </div>
          <div class>
            <span v-if="model.flagEstrangeiro==0">{{(model.tipFornecedor =='J') ? $t('label.cnpj') : $t('label.cpf')}}:</span>
            <span v-else>{{$t('label.documentoIdentificacao')}}: </span>
            <!-- <strong>{{model.numCgcFornecedor, model.tipFornecedor | cpfCnpjMask }}</strong> -->
            <strong>{{model.numCgcFornecedor, model.tipFornecedor | cpfCnpjMask }}</strong>
            <br>
            <div v-if="$verificaPerfilHabilitador()">
              <span >Processo SEI:<strong>{{model.numProcedimentoSEI}}</strong></span>
              <span style="float:center; padding:0px 0 0 0;" >
                <a v-show="model.linkProcedimentoSEI">
                  <v-tooltip top >
                      <img @click="redirecionaLinkSEI(model.linkProcedimentoSEI)" class="mx-1" slot="activator"
                        style="height: 20px; width:30px" src="../../assets/logo_sei.png"/>
                    <span>Acessar Documentos no SEI</span>
                  </v-tooltip>
                </a>
              </span>
            </div> 
          </div>
          <div class>
            Tipo de Cadastro:
            <strong>{{retornaEnumDescricao("tipoCertificado",model.tipoCertificado)}}{{(model.tipoCertificado != 3) ? ' - ' + model.tbFornecedores.vwCRC.numCrc : ''}}</strong>
          </div>
          <div class v-if="model.tipoCertificado != 3">
            Validade:
            <strong>{{model.tbFornecedores.vwCRC.datVencimentoCrc | dataFormatada}}</strong>
          </div>
          <div class>
            Categoria:
            <strong>{{retornaCategoria(model.categoria)}}</strong>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-layout>
    <v-flex xs12 sm6 md4 :class="{'p-t-30':!exibeCardFornecedor}">
      <v-select
        v-model="model.situacaoSolicitacao"
        :items="enumSituacaoSolicitacao"
        item-text="descricao"
        item-value="valor"
        :label="$t('label.situacaoSolicitacao')"
        clearable
        @input="filtrarTabelaCadastrados"
      ></v-select>
    </v-flex>

    <v-data-table
      :headers="headers"
      :items="solicitacaoListaFiltrada"
      class="tableLista gridImprimir"
    >
      <template slot="items" slot-scope="props">
        <tr
          v-bind:class="{'itemRejeitado':props.item.situacaoSolicitacao==4,'itemAprovado':props.item.situacaoSolicitacao==5}"
        >
          <td class="text-xs-center naoImprimir" nowrap style="max-width:150px">
            <v-tooltip top v-show="(props.item.situacaoSolicitacao==2 && !$verificaPerfilHabilitador()) || props.item.situacaoSolicitacao==4
            || props.item.situacaoSolicitacao==5 || props.item.situacaoSolicitacao==7 || props.item.situacaoSolicitacao==8 || props.item.situacaoSolicitacao==10">
              <v-btn slot="activator" icon @click="visualizarItem(props.item)">
                <v-icon color="primary">search</v-icon>
              </v-btn>
              <span>Visualizar</span>
            </v-tooltip>

            <v-tooltip
              top v-show="props.item.situacaoSolicitacao==1 || props.item.situacaoSolicitacao==12"
              v-if="!$verificaPerfilHabilitador() && podeContinuarEdicaoSolic(props.item)">
              <v-btn slot="activator" icon @click="openModalSolicitacaoEdicao(props.item)">
                <v-icon color="primary">edit</v-icon>
              </v-btn>
              <span>Alterar</span>
            </v-tooltip>

            <v-tooltip
              top v-show="props.item.situacaoSolicitacao==1 || props.item.situacaoSolicitacao==2"
              v-if="!$verificaPerfilHabilitador()">
              <v-btn slot="activator" icon @click="cancelarItem(props.item)">
                <v-icon color="error">block</v-icon>
              </v-btn>
              <span>Cancelar</span>
            </v-tooltip>
          </td>
          <td nowrap>{{ props.item.dataSolicitacao | dataHoraFormatada }}</td>
          <td nowrap class="somenteImprimir">{{ props.item.numSolicitacao }}</td>
          <td  v-if="$verificaPerfilHabilitador()" nowrap class="naoImprimir">{{props.item.dataAnalise | dataHoraFormatada }}</td>
          <td class="naoImprimir" nowrap v-if="props.item.situacaoSolicitacao === 4">
            {{props.item.motivo}} &nbsp;

            <v-tooltip top >
              <v-btn slot="activator" icon @click="documentosRejeitados(props.item)">
                <v-icon color="primary">search</v-icon>
              </v-btn>
              <span>Visualizar lista de documentos rejeitados</span>
            </v-tooltip>

          </td>
          <td class="naoImprimir" v-else>
            {{props.item.motivo}}
          </td>
          <td class="naoImprimir">{{ props.item.tipoSolicitacaoStr }}</td>
          <td nowrap v-if="props.item.situacaoSolicitacaoStr === 'Atualizada'">Deferida</td>
          <td nowrap v-else-if="props.item.situacaoSolicitacaoStr === 'Atualizada com Ressalvas'">
            Deferida Parcial</td>
          <td nowrap v-else-if="props.item.situacaoSolicitacaoStr === 'Aceitar'">
           Aguardando Análise</td>
          <td nowrap v-else-if="props.item.situacaoSolicitacaoStr === 'Rejeitar'">
           Indeferida</td>
          <td nowrap v-else>{{props.item.situacaoSolicitacaoStr}}</td>
          <td class="naoImprimir">{{ props.item.unidadeSolicitante }}</td>
        </tr>
      </template>
    </v-data-table>

    <div class="p-t-10 naoImprimir">
      <fieldset>
        <legend>Legendas</legend>
        <v-chip label outlined pill disabled>
          <v-icon left color="primary">search</v-icon>Visualizar
        </v-chip>
        <v-chip label outlined pill disabled v-if="!$verificaPerfilHabilitador()">
          <v-icon left color="primary">edit</v-icon>Alterar
        </v-chip>

        <v-chip label outlined pill disabled v-if="!$verificaPerfilHabilitador()">
          <v-icon left color="error">block</v-icon>Cancelar
        </v-chip>
      </fieldset>
    </div>
    <br><br><br>
    <!-- <v-dialog v-model="dialogUploadTermo.show" persistent max-width="520px" :key="dialogUploadTermoKey">
      <v-form ref="formTermo" v-model="dialogUploadTermo.validTermo">
        <v-card>
          <v-card-title class="headline">Termo de Concordância e Veracidade</v-card-title>
          <v-card-text>
            <v-flex inputIcon v-show="!dialogUploadTermo.termo.file.novoUpload">
              <v-text-field
                :value="subStrUpload(dialogUploadTermo.termo.arquivoUpload)"
                :label="$t('label.anexaDocumento')"
                clearable
                append-icon="get_app"
                readonly
                :rules="validaIfObrigatorio(!dialogUploadTermo.termo.file.novoUpload)"
                @click:clear="clearAnexo()"
                @click:append="baixarArquivo(dialogUploadTermo.termo.arquivoUpload)"
                persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex v-if="dialogUploadTermo.termo.file.novoUpload">
              <uploadFile
                tamanhoMaximo="20MB"
                required
                :label="$t('label.anexaDocumento')"
                v-model="dialogUploadTermo.termo.file.arquivoUpload"
                accept=".pdf, .PDF"
              />
            </v-flex>
          </v-card-text>
          <v-layout row p-b-15 p-t-10>
            <v-flex sm6>
              <v-btn large color="success" @click="closeModalUploadTermo()">Cancelar</v-btn>
            </v-flex>
            <v-flex sm6>
              <v-btn large color="info" @click="confirmarEnvioTermo()">Confirmar</v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-form>
    </v-dialog> -->
     <v-dialog v-model="dialogSolicitacaoEdicao.show" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">Alterar Solicitação ?</v-card-title>
        <v-card-text>
         <div v-html="dialogSolicitacaoEdicao.subtitulo"></div>
          <!-- <strong>{{dialogSolicitacaoEdicao.subtitulo}}</strong>. -->
        </v-card-text>
        <v-layout row p-b-15 p-t-10>
          <v-flex sm6>
            <v-btn large color="info" @click="closeModalSolicitacaoEdicao()">Cancelar</v-btn>
          </v-flex>
          
          <v-flex sm6>
            <v-btn large color="success" 
            @click="editItem(dialogSolicitacaoEdicao.item)">OK</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
     <v-dialog v-model="dialogMensagemTermo" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">Atenção!</v-card-title>
        <v-card-text>
          <p>Prezado Fornecedor,</p>
          <p>Para prosseguimento da análise, aguardamos o envio do Termo de Declaração de Concordância e Veracidade,
            disponível em: acesso cadastro > solicitações > Termo de Concordância e Veracidade.</p>
          <p class="text-danger">Caso tenha encaminhado o documento informado desconsiderar a informação acima.</p>
        </v-card-text>
        <v-layout row p-b-15 p-t-10>
          <v-flex sm6>
            <v-btn large color="info" @click="dialogMensagemTermo = false;">OK</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <fornecedorrepresentantelegal v-if="dialogRepresentante" 
      :dados="modelRepresentante" 
      :aberto="dialogRepresentante" 
      @onSaveRepresentante="goToCadastro" 
      :persistente="true">
    </fornecedorrepresentantelegal>
    <RodapeImpressao class="imprimir" hidden></RodapeImpressao>
  </div>
</template>
<script>
import util from "../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import Migalha from "../../components/migalha";
import Topo from "../../components/Topo";
import CabecalhoImpressao from "../../components/cabecalho-impressao";
import RodapeImpressao from "../../components/rodape-impressao";
import fornecedorService from "../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import dominioService from "../../services/dominioService";
import uploadDeclaracaoService from "../../services/uploadDeclaracaoService";
import fornecedorrepresentantelegal from "./components/fornecedorrepresentantelegal";
import Print from "vue-print-nb";
import Vue from "vue";
import UploadArquivoSEIVue from '../../components/UploadArquivoSEI.vue';

export default {
  name: "solicitacaoLista",
  mixins: [util],
  components: { /*Componentes utilizados*/
    Migalha,
    Topo,
    CabecalhoImpressao,
    RodapeImpressao,
    fornecedorrepresentantelegal
  },
  props: {//Propriedades que o objeto recebe como parametro
    numCgcFornecedorProp: Object
  },
  computed:{
    exibeCardFornecedor: function () {
      return this.modelCarregado && (this.$verificaPerfilCadastrador() || this.$verificaPerfilHabilitador());
    },
  },
  created() /*Metodo de start do componente*/{
    Vue.use(Print);
    this.$mostrarPreload();
    this.getCombosDadosBasicos();
    dominioService.geEnums().then(response => { /*resposta do servico*/
      this.enums = response.data; /*dados de retorno*/
        this.enumSituacaoSolicitacao = this.enums.situacaoSolicitacao.filter(x=>x.chave === "PendenteEnvio"
        || x.chave === "EmAnalise"
        || x.chave === "AguardandoAnalise"
        || x.chave === "AtualizadaRessalvas"
        || x.chave === "Atualizada"
        || x.chave === "Indeferida"
        || x.chave === "Deferida"
        || x.chave === "Cancelada");       
        this.getFornecedorSIMPAS();
        this.getPossuiTermoAceito();
    });
  },
  data() {//Declaracao de variaveis
    return {
      headers: [ /*Cabeçalho da data-table*/],
      solicitacaoLista: [],
      solicitacaoListaFiltrada: [],
      uploadDeclaracao: Object,
      dialog: false,
      valid: true,
      veracidadecarregado:false,
      dialogMensagemTermo:false,
      enums: {},
      enumSituacaoSolicitacao:[],
      model:{
        situacaoSolicitacao: null
      },
      //dialogUploadTermoKey: 1,
      // dialogUploadTermo: {
      //   validTermo: true,
      //   show: false,
      //   termo:{
      //     idUploadDeclaracao: null,
      //     idFornecSolicitacao: null,
      //     tipDocumento: 150,
      //     uploadDeclaracaoSituacao: null,
      //     arquivoUpload: null,
      //     idMotivoIndeferimentoArquivo: null,
      //     assinadoDigitalmente:'1',
      //     file: {
      //       arquivoUpload: null,
      //       novoUpload: true
      //     }
      //   }
      // },
      dialogRepresentante: false,
      dialogSolicitacaoEdicao: {
        show: false,
        texto:"Alterar Solicitação",
        subtitulo:"Atenção! Ao realizar alteração na solicitação o seu pedido inicial será cancelado.",
        item:null,
      },
      modelRepresentante: {},
      possuiTermoAceito: false,
      modelCarregado: false
    };
  },
  methods: {//Declaracao de todos os metodos
    openCadastrarFornecedor() {
      this.dialog = true;
    },
    verificarExibicaoMensagemTermo() {
      if(this.existeSolicitacaoAguardandoAnalise() && this.flMostrarMsgTermoVeracidade()) {
        //this.dialogMensagemTermo = true;
      }
    },
    flMostrarMsgTermoVeracidade() {
      return !this.$verificaPerfilCadastrador()
        && !this.$verificaPerfilHabilitadorMaster()
        && (!this.veracidadecarregado || this.uploadDeclaracao.termoConcordanciaVeracidadeSaeb == 'Não Encontrado' ) // || this.solicitacaoComTermoRejeitado)
        && !this.possuiTermoAceito
    },
    getCombosDadosBasicos() {
      //resgatar os combos de dados basicos
      dominioService.getCombosDadosBasicos().then(response => { /*resposta do servico*/
        this.dominio = response.data; /*dados de retorno*/
      });
    },
    getFornecedorSIMPAS() {
      //resgatar os dados do fornecedor
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      let numCgcFornecedor =
        this.$route.params.id && this.$verificaPerfilHabilitador()
          ? this.$route.params.id
          : null;
      if(this.$verificaPerfilFornecedor()) numCgcFornecedor = this.$store.getters.getUsuarioId;
      numCgcFornecedor = this.numCgcFornecedorProp ? this.numCgcFornecedorProp.texto : numCgcFornecedor

      fornecedorService.getFornecedorSIMPAS(numCgcFornecedor,"sim").then(response => { /*resposta do servico*/

        if(response.data != "")
        {
          this.model = response.data; /*dados de retorno*/
          this.modelCarregado = true;
          this.retornaDocs();
        }
        this.$removePreload(); /*Ocultar o PreLoad*/

        this.carregarTabelaCadastrados();
      })
      .catch(error => {
            this.$removePreload(); /*Ocultar o PreLoad*/
        });
    },

    retornaDocs(){
        //carrega os possiveis documentos de formularios e declaracoes
        let upload = {
          termoConcordanciaVeracidadeSaeb: this.verificaDoc(this.model.uploadDeclaracao.find(
            x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(
              y => y.chave === 'TermoConcordanciaVeracidadeSaeb').valor)),
        };
        this.uploadDeclaracao = upload;
        this.veracidadecarregado = true;
      },
      verificaDoc(obj) {
        var retorno = ""
        if (obj != null) {
          retorno = obj.arquivoUpload
        }
        return retorno;
      },

    solicitarAlteracao() {
      
      //solicitar uma alteração de cadastro
      let numCgc = null;
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      if(this.model.sitFornecedor === 5) /*se a situação for Suspenso indeterminado*/
      {
        this.$removePreload();
        this.$toasted.error(this.$t('messages.validacao.situacaoFornecedorSuspenso'));
        return;
      }
      if(this.$verificaPerfilCadastrador() || this.$verificaPerfilHabilitador()){
        numCgc = this.$route.params.numCgcFornecedor;
      }else{
        numCgc = this.$store.getters.getUsuarioId;
      }
      fornecedorService.solicitarAlteracao(numCgc).then((response) => {
        this.$mostrarPreload(); 
        if(this.$verificaPerfilFornecedor()){
          fornecedorService.getRepresentanteLegalFornecedor(this.$store.getters.getUsuarioId).then(
            response =>
            { 
              if(response.data != null)
              {
                this.modelRepresentante.representanteLegal = response.data;
                if(this.modelRepresentante.representanteLegal.cpf == null){
                  this.dialogRepresentante = true;
                }else{
                  this.$router.push("/cadastro/alterar");
                }
              }else{
                this.dialogRepresentante = true;
              }
            }
          );
        }else{
          this.$router.push({path: `/cadastro/modificar/${numCgc}`});
        }
        this.$removePreload(); /*Ocultar o PreLoad*/
      });
    },

    goToCadastro(representanteSalvo){
      if(representanteSalvo) this.$router.push("/cadastro");
    },

    termoConcordancia(){
      this.$router.push("/termo-declaracao-concordancia/" + this.solicitacaoLista[0].idFornecSolicitacao + "/2");
    },
    baixarArquivo(arquivo) {
      //baixar o arquivo
      const numCgcFornecedor = this.$verificaPerfilCadastrador() ?
        this.model.numCgcFornecedor.replace(/[\W_]+/g, "") :
        null;
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },

    solicitarCadastro() {
      //solicitar um cadastro novo
      let numCgc = null;
      if(this.$verificaPerfilCadastrador() || this.$verificaPerfilHabilitador()){
        numCgc = this.$route.params.numCgcFornecedor;
      }else{
        numCgc = this.$store.getters.getUsuarioId;
      }
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService.solicitarNovoCadastro(numCgc).then(response => { /*resposta do servico*/
         if (this.$verificaPerfilCadastrador()){
          this.$router.push("/arearestrita/cadastrador/cadastrar-solicitacao/" + response.data.idFornecSolicitacao);
         }else{
           this.$router.push("/cadastro");
         }
          this.$removePreload(); /*Ocultar o PreLoad*/
        });
    },

    visualizarItem(item) {
      //visualizar solicitação escolhida
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      this.$router.push({
        path: `/resumo-solicitacao/${item.idFornecSolicitacao}`
      });
    },
    documentosRejeitados(item){
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      this.$router.push({
        path:
          // item.tipoSolicitacao é do tipo number
          '/indeferimento-resumo/' +  item.idFornecSolicitacao
      });
      this.$removePreload(); /*Ocultar o PreLoad*/

    },
    editItem(item) {
      //ediatar solicitação escolhida
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService
        .fornecedorReabrirSolicitacao(item.idFornecSolicitacao)
        .then(response => { /*resposta do servico*/
          if (response.data == true) {
            // #156569-Permitir cadastrador editar sua propria solicitacao no historico
            if(this.$verificaPerfilCadastrador()){
               this.$router.push({
                path: 
                   `/arearestrita/cadastrador/cadastrar-solicitacao/${item.idFornecSolicitacao}`
              });
            }
            else{
              this.$router.push({
                path:
                  // item.tipoSolicitacao é do tipo number
                  item.tipoSolicitacao === 1 ? `/cadastro` : `/cadastro/alterar`
              });
            }


            this.$removePreload(); /*Ocultar o PreLoad*/
          }
        });
    },
    cancelarItem(item) {
      //cancelar solicitacao escolhida
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      fornecedorService
        .fornecedorCancelarSolicitacao(item.idFornecSolicitacao)
        .then(response => { /*resposta do servico*/
          if (response.data == true) {
            this.carregarTabelaCadastrados();
            this.$removePreload(); /*Ocultar o PreLoad*/
            this.$toasted.success("Cancelado com sucesso.");
          }
        });
    },

    carregarTabelaCadastrados() {
      //carregar a lista de solicitacoes do fornecedor
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      this.headers = [
        {
          text: "Ações",
          value: "",
          width: 5,
          sortable: false,
          class: "text-xs-center naoImprimir"
        },
        {
          text: "Data Solicitação",
          value: "dataSolicitacao",
          width: 3,
          sortable: false
        },
        {
          text: "Nº Solicitação",
          value: "numSolicitacao",
          width: 3,
          sortable: false,
          class: "somenteImprimir"
        },
        {
          text: "Motivo",
          value: "motivo",
          width: 10,
          sortable: false,
          class: "naoImprimir"
        },
        {
          text: "Tipo da solicitação",
          value: "TipoSolicitacao",
          width: 10,
          sortable: false,
          class: "naoImprimir"
        },
        {
          text: "Situação da Solicitação",
          value: "situacaoSolicitacaoStr",
          width: 3,
          sortable: false,
        },
        {
          text: "Unidade Solicitante ",
          value: "unidadeSolicitante",
          width: 10,
          sortable: false,
          class: "naoImprimir"
        }
      ];

      //Insere data analise após data solicitação, campo visto somente pelo habilitador.
      if(this.$verificaPerfilHabilitador()){
        this.headers.splice(2,0,{text: "Data Analise", value: "dataAnalise", width: 10, sortable: false});
      }

      let numCgcFornecedor =
        this.$route.params.id && this.$verificaPerfilHabilitador()
          ? this.$route.params.id
          : null;
      numCgcFornecedor = this.numCgcFornecedorProp ? this.numCgcFornecedorProp.texto : numCgcFornecedor

      fornecedorService.listarSolicitacoes(numCgcFornecedor).then(response => { /*resposta do servico*/
        this.solicitacaoLista = response.data; /*dados de retorno*/
        this.solicitacaoListaFiltrada = response.data; /*dados de retorno*/   
        this.verificarExibicaoMensagemTermo();
        this.$removePreload(); /*Ocultar o PreLoad*/
      });
    },

    filtrarTabelaCadastrados(situacao){
      //filtar as solicitacoes
      if (situacao)
        this.solicitacaoListaFiltrada = this.solicitacaoLista.filter(x => x.situacaoSolicitacao === situacao);
      else
        this.solicitacaoListaFiltrada = this.solicitacaoLista;
    },

    existeSolicitacaoImpeditiva(){
      //Pendente de envio(1) / Aguardando Analise(2) / Em Analise(3) / Aceitar(9) 
      const situacoesImpeditivas = [1, 2, 3, 9, 11];
      if(this.solicitacaoLista.length > 0 && this.solicitacaoLista[0].situacaoSolicitacao == 7) return false;

      
      return this.solicitacaoLista.find(x => situacoesImpeditivas.includes(x.situacaoSolicitacao));
    },
    sotemCancelada(){
      const todasSolicitacoesSeisOuUm = this.solicitacaoLista.every(solicitacao => 
      solicitacao.situacaoSolicitacao === 6 || solicitacao.situacaoSolicitacao === 1
      );

      if (todasSolicitacoesSeisOuUm) {
        return true;
      }
      else {
        return false;
      }
    },

    existeSolicitacaoAguardandoAnalise(){
      // Aguardando Analise(2)
      const situacoesImpeditivas = [2];
      if(this.solicitacaoLista.length > 0 && this.solicitacaoLista[0].situacaoSolicitacao == 7) return false;
      return this.solicitacaoLista.some(x => situacoesImpeditivas.includes(x.situacaoSolicitacao));
    },

    openModalUploadTermo(){
     
      if(this.solicitacaoLista.length > 0 && !(this.solicitacaoLista[0].situacaoSolicitacao == 6 && this.$verificaPerfilHabilitador())){
      this.clearModelTermo();
      this.clearAnexo();
      this.dialogUploadTermo.solicitacao = this.solicitacaoLista[0];
      if([4,5,7,8].includes(this.dialogUploadTermo.solicitacao.situacaoSolicitacao) || this.solicitacaoLista.length === 0) return;

      this.$mostrarPreload();
      uploadDeclaracaoService.consultaTermoFornecedor(this.dialogUploadTermo.solicitacao.idFornecSolicitacao).then(
        response => {
          if(response.data != null){
            this.dialogUploadTermo.termo = response.data;
            if(!!this.dialogUploadTermo.termo.arquivoUpload && this.dialogUploadTermo.termo.dtRejeicao == null){
              this.dialogUploadTermo.termo.file = {
                arquivoUpload: null,
                novoUpload: false
              }
            }else{
              this.dialogUploadTermo.termo.file = {
                arquivoUpload: null,
                novoUpload: true
              } 
            }
            this.dialogUploadTermo.termo.dtRejeicao = null;
          }else{
            this.dialogUploadTermo.termo.idFornecSolicitacao = this.dialogUploadTermo.solicitacao.idFornecSolicitacao;
          }
          this.$removePreload(); 
          this.dialogUploadTermoKey++;
          this.dialogUploadTermo.show = true;
        }
      );
      }
      else
      {
        this.$toasted.success("A ultima solicitação precisa estar em uma situação diferente de Cancelada.");

      }
    },

    closeModalUploadTermo(){
      this.clearModelTermo();
      this.clearAnexo();
      this.dialogUploadTermo.show = false;
    },

    // clearModelTermo(){
    //   this.dialogUploadTermo.termo = {
    //     idUploadDeclaracao: null,
    //     idFornecSolicitacao: null,
    //     tipDocumento: 150,
    //     uploadDeclaracaoSituacao: null,
    //     arquivoUpload: null,
    //     idMotivoIndeferimentoArquivo: null,
    //     assinadoDigitalmente:'1',
    //     file: {
    //       arquivoUpload: null,
    //       novoUpload: true
    //     }
    //   };
    //   this.dialogUploadTermo.solicitacao = {};
    // },

    // clearAnexo(){
    //   this.dialogUploadTermo.termo.arquivoUpload = null;
    //   this.dialogUploadTermo.termo.file.novoUpload = true;
    //   this.dialogUploadTermo.termo.file.arquivoUpload = null;
    // },

    // confirmarEnvioTermo(){
    //   if(this.$refs.formTermo.validate()){
    //     this.dialogUploadTermo.termo.assinadoDigitalmente = '1';
    //     var model = {uploadDeclaracao: this.dialogUploadTermo.termo, file: this.dialogUploadTermo.termo.file};
    //     uploadDeclaracaoService.salvarTermo(model).then(
    //       response => {
    //         this.closeModalUploadTermo();
    //         this.$toasted.success(this.$t("messages.cadastro.cadastroDocumentoSucesso"));
    //         this.carregarTabelaCadastrados();
    //       }
    //     );
    //   }
    // },

    validaIfObrigatorio(valida){
      if(valida){
        return this.validacao.campoObrigatorio;
      }
      return [];
    },

    solicitacaoComTermoRejeitado(){
      if ( this.solicitacaoLista.length > 0){
        return (this.solicitacaoLista[0].situacaoSolicitacao === 10);
      }
      return false;
    },
    
    openModalSolicitacaoEdicao(item){
      if(item.situacaoSolicitacao == 2) {
        this.dialogSolicitacaoEdicao.show=true;
        this.dialogSolicitacaoEdicao.item=item;
      } else { 
        this.editItem(item);
      }

    },

    closeModalSolicitacaoEdicao(){
      this.dialogSolicitacaoEdicao.show=false;
       this.dialogSolicitacaoEdicao.item=null;
    },

    podeSolicitarAlteracao(){

      return ( (this.$getStatusSIMPAS()!=null || this.$verificaPerfilCadastrador() ) &&
                !this.existeSolicitacaoImpeditiva()  &&
                !this.$verificaPerfilHabilitador());
    },
    podeSolicitarCadastro(){
      return (this.$getStatusSIMPAS()==null && 
              !this.existeSolicitacaoImpeditiva() && 
              !this.$verificaPerfilHabilitador() &&
              (this.solicitacaoLista.length > 0 && this.solicitacaoLista[0].tipoSolicitacao === 1));
    },
    getPossuiTermoAceito(){
        var numCgcFornecedor;
        if(this.$route.params.id && this.$verificaPerfilHabilitador()){
          numCgcFornecedor = this.$route.params.id;
        }
        else if(this.$verificaPerfilFornecedor()){
          numCgcFornecedor = this.$store.getters.getUsuarioId;
        } 
        numCgcFornecedor = this.numCgcFornecedorProp ? this.numCgcFornecedorProp.texto : numCgcFornecedor;
        uploadDeclaracaoService.possuiTermoAceito(numCgcFornecedor).then( response => {
          this.possuiTermoAceito = response.data;
        });
    },

    retornaEnumDescricao(_enum, valor) {
      //retorna a descricao do enum
      if (valor == null || !this.enums[_enum] == null) return "";

      // condição para que não busque (.find) num enum vazio e dê erro
      if(this.enums[_enum] && this.enums[_enum] != undefined && this.enums[_enum] !== ""){
        let retorno = this.enums[_enum].find(x => x.valor === valor);
        //verificar se retorno foi preenchido
        if (retorno)
          return retorno.descricao;
        else
          return null;
      } else {
        return null;
      }
    },

    retornaCategoria(cod_categoria) {
      //retorna a categoria
      if (!cod_categoria) return "";
      let categoria = this.dominio.categoria.find(
        x => x.categoria === cod_categoria
      );
      return categoria ? categoria.descricao : null;
    },

    redirecionaLinkSEI(endereco){
       //abre nova guia com o procedimento SEI
       const link = document.createElement('a');
        var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
        if(regex .test(endereco)) {
            link.href = endereco;
            link.setAttribute('download', endereco);
            link.setAttribute('target', "_blank");
            document.body.appendChild(link);
            link.click();
            return true;
        }
        return false;
    },

    podeContinuarEdicaoSolic(item){
    // #152150-Nao permitir fornecedor editar uma solicitacao criada pelo cadastrador
   
      if(this.$verificaPerfilFornecedor()){
        if(item && item.usuarioCadastradorId && (item.situacaoSolicitacao==1 || item.situacaoSolicitacao==12)){
          return false;
        }
      }
      return true;
    },
  }
};
</script>

<style scope>
.theme--light.v-chip,
.v-chip:focus,
.v-chip--active,
.v-chip--selected {
  background: none !important;
  color: rgba(0, 0, 0, 0.87) !important;
}
.itemRejeitado td {
  color: red !important;
}

.itemAprovado td {
  color: #388e3c !important;
  font-weight: bold !important;
}
.link_color{
  color: orange !important;
  font-family: gothambold !important;
  background: none !important;
}
.text_color{
  font-family: gothambold !important;
  color:#106187  !important;
  background: none !important;
}
.text_bold_color{
  font-weight: 900 !important;
  font-family: gothambold !important;
  color: #190866 !important;
  background: none !important;
}

.boxConteudoNomeFornecedor {
  background: url("/images/bg1.png") repeat center center;
  border: 1px solid #cdcdcd;
  text-align: center;
}
.text-danger {
  color: #dc3545 !important;
}
</style>
